module.exports = __webpack_public_path__ + "img/KBANK.c4b83127.png";